import {directorySearchTerms, matchesDirectorySearch} from "./directorySearch";

// Project only published directory fields. Never export raw API objects.
const published = value => value === true || value === 1 || value === '1';
const text = value => value === null || value === undefined ? '' : String(value);
const list = value => Array.isArray(value) ? value : [];

export function formatDirectoryAddress(address = {}) {
    const locality = [address.city, address.state_province_region].filter(Boolean).join(', ');
    return [address.address_line1, address.address_line2,
        [locality, address.postal_code].filter(Boolean).join(' '), address.country].filter(Boolean).join('\n');
}

export function getPublishedDirectory(lots, {includeMailingAddresses = false, search = ''} = {}) {
    const terms = directorySearchTerms(search);
    return list(lots).map(lot => ({
        neighborhood: text(lot.neighborhood), lotNumber: text(lot.lot_number),
        address: formatDirectoryAddress(lot.lot_address || {}),
        owners: list(lot.owners).filter(owner => published(owner.show_public_directory)).map(owner => ({
            name: text(owner.owner_name),
            phones: list(owner.phone_numbers).filter(phone => published(phone.show_public_directory))
                .map(phone => text(phone.phone_number)).filter(Boolean),
            emails: list(owner.email_addresses).filter(email => published(email.show_public_directory))
                .map(email => text(email.email_address)).filter(Boolean),
            mailingAddresses: includeMailingAddresses ? list(owner.mailing_addresses)
                .filter(address => published(address.show_public_directory)).map(formatDirectoryAddress).filter(Boolean) : [],
        })),
    })).filter(lot => lot.owners.length > 0)
        .filter(lot => matchesDirectorySearch([lot.neighborhood, lot.lotNumber, lot.address,
            ...lot.owners.flatMap(owner => [owner.name, ...owner.phones, ...owner.emails, ...owner.mailingAddresses])], terms))
        .sort((a, b) => a.neighborhood.localeCompare(b.neighborhood) || a.lotNumber.localeCompare(b.lotNumber, undefined, {numeric: true}));
}

function csvCell(value) {
    let cell = text(value);
    // Spreadsheet programs must treat user-provided values as text, not formulas.
    if (/^[\s]*[=+@-]/.test(cell) || /^[\t\r\n]/.test(cell)) cell = "'" + cell;
    return '"' + cell.replace(/"/g, '""') + '"';
}

export function publishedDirectoryCsv(households, {includeMailingAddresses = false} = {}) {
    const rows = [['Neighborhood', 'Lot', 'Residence address', 'Resident', 'Phone numbers', 'Email addresses',
        ...(includeMailingAddresses ? ['Mailing addresses'] : [])]];
    households.forEach(lot => lot.owners.forEach(owner => rows.push([
        lot.neighborhood, lot.lotNumber, lot.address, owner.name, owner.phones.join('\n'), owner.emails.join('\n'),
        ...(includeMailingAddresses ? [owner.mailingAddresses.join('\n\n')] : []),
    ])));
    return '\uFEFF' + rows.map(row => row.map(csvCell).join(',')).join('\r\n') + '\r\n';
}
